<app-breadcrumb [master]="'Należności'" [parentName]="'Wpłaty'" [name]="'Lista Importów'"></app-breadcrumb>
<div class="receivables-payment-import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="receivables-payment-import-list-filters">

    <mat-form-field class="receivables-payment-import-list-filter">
      <mat-label>Nazwa pliku</mat-label>
      <input matInput placeholder="Nazwa pliku" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <app-datepicker
      class="receivables-payment-import-list-filter"
      label="Data importu od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="receivables-payment-import-list-filter"
      label="Data importu do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict-users
      label="Użytkownik"
      class="receivables-payment-import-list-filter"
      [(ngModel)]="initialFilters.createdBy" name="createdBy"
    ></app-dict-users>

    <app-dict
      [multiple]="true" label="Status"
      class="receivables-payment-import-list-filter"
      dictType="import_status"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>

    <mat-form-field class="receivables-payment-import-list-filter">
      <mat-label>Liczba transakcji</mat-label>
      <input matInput placeholder="Liczba transakcji" name="importedPayment" [(ngModel)]="initialFilters.importedPayment">
    </mat-form-field>

  </form>

  <div class="receivables-payment-import-list-buttons">
    <button (click)="filter()"  mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>

  </div>

  <table mat-table [dataSource]="imports" >

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        <div class="statusChange-flex-container">
          {{element.name}}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data importu </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{ element.createdBy.firstName }} {{ element.createdBy.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalRows">
      <th mat-header-cell *matHeaderCellDef>  Liczba transakcji </th>
      <td mat-cell *matCellDef="let element">
        {{element.importedPayment}}
<!--        <mat-progress-bar *ngIf="element.status.key === IMPORT_STATUS_IN_PROGRESS"-->
<!--                          class="example-margin"-->
<!--                          [color]="color"-->
<!--                          [mode]="mode"  >-->
<!--        </mat-progress-bar>-->
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div fxLayout="column" >
          <button *ngIf="(userPermissions | async).receivables.admin_root"   fxFlex="100"  mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables?.read_report"  mat-menu-item (click)="downloadImportFile(element)">Pobierz plik importu</button>
            <button  [disabled]="!(userPermissions | async).receivables.admin_root" mat-menu-item (click)="deleteImport(element)">Usuń</button>
          </mat-menu>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
